import { ref, get, child, update, set } from "firebase/database";
import { dbAsistencia } from "../firebase";

const LOCATION_PATH = "location";

function toNumberOr(defaultValue, value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : defaultValue;
}

export async function listLocations() {
  const root = ref(dbAsistencia);
  const snap = await get(child(root, LOCATION_PATH));
  if (!snap.exists()) return [];
  const data = snap.val() || {};

  return Object.entries(data).map(([id, v]) => ({
    id,
    name: String(v?.name || id),
    lat: toNumberOr(0, v?.lat ?? v?.latitude),
    lng: toNumberOr(0, v?.lng ?? v?.longitude),
    radius: toNumberOr(0, v?.radius),
    active: typeof v?.active === "boolean" ? v.active : true,
  }));
}

export async function saveLocation(locationId, payload) {
  const id = String(locationId || "").trim();
  if (!id) throw new Error("locationId requerido.");

  const updates = {
    name: String(payload?.name || id).trim(),
    lat: toNumberOr(0, payload?.lat),
    lng: toNumberOr(0, payload?.lng),
    latitude: toNumberOr(0, payload?.lat),
    longitude: toNumberOr(0, payload?.lng),
    radius: Math.max(1, toNumberOr(100, payload?.radius)),
    active: payload?.active !== false,
  };

  await update(ref(dbAsistencia, `${LOCATION_PATH}/${id}`), updates);
  return { id, ...updates };
}

export async function createLocation(locationId, payload) {
  const id = String(locationId || "").trim();
  if (!id) throw new Error("locationId requerido.");
  const location = {
    name: String(payload?.name || id).trim(),
    lat: toNumberOr(0, payload?.lat),
    lng: toNumberOr(0, payload?.lng),
    latitude: toNumberOr(0, payload?.lat),
    longitude: toNumberOr(0, payload?.lng),
    radius: Math.max(1, toNumberOr(100, payload?.radius)),
    active: payload?.active !== false,
  };
  await set(ref(dbAsistencia, `${LOCATION_PATH}/${id}`), location);
  return { id, ...location };
}
